export default __webpack_public_path__ + "d712015571690b15e273bf4caa2d88b4.svg";